import React, { ReactNode } from 'react'
import { useTranslation } from 'next-i18next'
import Head from 'next/dist/shared/lib/head'
import PublicDashboardHeader from 'shared/components/public-dashboard-header'

interface UnsubscribePageLayoutProps {
  children: React.ReactNode
}

function UnsubscribePageLayout({ children }: UnsubscribePageLayoutProps): ReactNode {
  const { t } = useTranslation()

  return (
    <>
      <Head>
        <title>{t('unsubscribe_page.unsubscribe.title')}</title>
      </Head>
      <div className="flex min-h-screen flex-col">
        <PublicDashboardHeader />
        <div className="grid flex-1 place-items-center px-5">
          <div className="mx-auto max-w-lg rounded-lg bg-background-secondary px-12 pt-12 pb-[56px] text-center shadow-lg lg:w-[500px]">
            {children}
          </div>
        </div>
      </div>
    </>
  )
}

export const getUnsubscribePageLayout = (page: ReactNode): ReactNode => (
  <UnsubscribePageLayout>{page}</UnsubscribePageLayout>
)
